import React, { FC } from 'react'

import {
	PAGE_ACTIVITIES,
	PAGE_ALERTS,
	PAGE_ASSIGN,
	PAGE_CHAT,
	PAGE_DASHBOARD,
	PAGE_PATIENTS,
	PAGE_TASKS,
} from '@app/constants/navigation'
import { AppIcon } from '@app/components/AppIcon'
import {
	SidebarAlertIcon,
	SidebarChatIcon,
	SlideMenuNavigation,
} from '@app/pages/Dashboard/SideBar/SlideMenu/SlideMenuItems/SlideMenuNav/styled'
import SidebarNavLink from '@app/pages/Dashboard/SideBar/components/SidebarNavLink'
import SidebarNavAccordeon from '@app/pages/Dashboard/SideBar/components/SidebarNavAccordeon/SidebarNavAccordeon'

interface SlideMenuNavProps {
	readonly locationPathName: string
	readonly minimize?: boolean
	readonly clinicManageTabsSlot?: React.ReactNode
	readonly searchOrgTabSlot?: React.ReactNode
	readonly assignPatientsTabSlot?: React.ReactNode
}

const SidebarNavAccordeonMenuItemSx = { mb: 3.5 }

const SlideMenuNav: FC<SlideMenuNavProps> = ({
	minimize,
	clinicManageTabsSlot,
	searchOrgTabSlot,
	assignPatientsTabSlot,
	locationPathName,
}: SlideMenuNavProps) => {
	return (
		<SlideMenuNavigation minimize={minimize}>
			<SidebarNavLink
				startIconSlot={
					<AppIcon
						type={'blocks'}
						style={{ marginRight: '0.8rem' }}
					/>
				}
				to={PAGE_DASHBOARD}
				label={'Dashboard'}
				checked={locationPathName === PAGE_DASHBOARD}
				sx={{ mb: 3 }}
			/>

			<SidebarNavAccordeon
				openLabel={'My Patients'}
				minimize={minimize}
				openIconSlot={
					<AppIcon
						type={'patients'}
						style={{ marginRight: '0.8rem' }}
					/>
				}
				sx={{ mb: 1.25, pr: 4 }}
				checked={
					locationPathName?.includes(PAGE_PATIENTS) ||
					locationPathName?.includes(PAGE_ASSIGN)
				}
				menuData={
					<>
						<SidebarNavLink
							to={PAGE_PATIENTS}
							label={'Patient overview'}
							sx={SidebarNavAccordeonMenuItemSx}
							checked={locationPathName?.includes(PAGE_PATIENTS)}
						/>

						{assignPatientsTabSlot}
					</>
				}
			/>

			<SidebarNavLink
				startIconSlot={<SidebarAlertIcon />}
				to={PAGE_ALERTS}
				label={'Alerts'}
				checked={locationPathName === PAGE_ALERTS}
				sx={{ mb: 3.25 }}
			/>

			<SidebarNavLink
				startIconSlot={<SidebarChatIcon />}
				to={PAGE_CHAT}
				label={'Chat'}
				checked={locationPathName === PAGE_CHAT}
				sx={{ mb: 3 }}
			/>

			<SidebarNavAccordeon
				openLabel={'Activities'}
				minimize={minimize}
				openIconSlot={
					<AppIcon
						type={'pillows'}
						style={{ marginRight: '0.8rem' }}
					/>
				}
				sx={{ mb: 2, pr: 4 }}
				checked={
					locationPathName?.includes(PAGE_ACTIVITIES) ||
					locationPathName?.includes(PAGE_TASKS)
				}
				menuData={
					<>
						<SidebarNavLink
							to={PAGE_ACTIVITIES}
							label={'Calendar'}
							sx={SidebarNavAccordeonMenuItemSx}
							checked={locationPathName === PAGE_ACTIVITIES}
						/>

						<SidebarNavLink
							to={PAGE_TASKS}
							label={'Tasks'}
							sx={SidebarNavAccordeonMenuItemSx}
							checked={locationPathName === PAGE_TASKS}
						/>
					</>
				}
			/>

			{clinicManageTabsSlot}

			{searchOrgTabSlot}
		</SlideMenuNavigation>
	)
}

export default SlideMenuNav
